import React, { useContext } from 'react';
import './FilterMenu.module.scss';
import { useSelector } from 'react-redux';

// Import components
import { FilterOptions, HomeContext } from 'screens/Home/Home';
import FilterItem from './FilterItem/FilterItem';

const FilterOptionsValues: FilterOptions[] = [
  'eenmalig contact',
  'serie sessies',
  'fysiek contact',
  'voorbereiding',
  'nazorg',
];

export default function FilterMenu() {
  const { activeFilters } = useContext(HomeContext);

  // get stuff from store
  const categories: any[] = useSelector((state) =>
    state.category.entities.allIds.map(
      (postId) => state.category.entities.byId[postId]
    )
  );

  return (
    <div styleName="filter-menu">
      <div styleName="inner">
        <div styleName="filters">
          {categories.map((item, i) => (
            <FilterItem
              active={activeFilters.includes(item.id)}
              filterName={item.name}
              filterId={item.id}
              key={i}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
